import React, {useState} from 'react';
import {Button} from '@material-ui/core';
import {reduxToggleSidePanel, reduxUpdateProduct} from 'appredux/actions';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Route} from 'react-router-dom';
import {
  IDepot,
  IFarmInputProduct,
  IProductPromoteInput,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {PromoteProductForm} from 'components/ProductForm/PromoteProductForm';
import {apiCreateProductPromotion, apiGetInputProduct} from 'constants/Api';

export default function PromoteProduct(props: {
  user: ISupplierUserProfile;
  product: IFarmInputProduct;
  depots: IDepot[];
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyUpdated, setHasSuccessfullyUpdated] = useState(false);

  const onCreatePromotion = (promotion: IProductPromoteInput) => {
    setIsLoading(true);
    apiCreateProductPromotion(promotion)
      .then((response) => {
        if (!response.success) throw Error(response.message);
        setHasSuccessfullyUpdated(true);
      })
      .then(() => apiGetInputProduct(promotion.inputProductId.toString()))
      .then((productUpdate) => reduxUpdateProduct(productUpdate))
      .catch((err) => {
        alert(
          'Failed to promote product at the moment. Please try again later',
        );
        console.error('Failed to promote product', err);
      })
      .finally(() => setIsLoading(false));
  };

  if (hasSuccessfullyUpdated) {
    return (
      <Route
        render={({history}) => (
          <div className="side-panel-success-container">
            <div className="mid-section">
              <div className="success-gif">
                <CheckIcon />
              </div>
              <div className="success-msg">Successfully promoted product</div>
            </div>
            <div className="btn-container">
              <Button
                className="primary-btn"
                type="submit"
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => reduxToggleSidePanel(false, null)}
              >
                View Products
              </Button>
            </div>
          </div>
        )}
      />
    );
  }

  return (
    <PromoteProductForm
      productId={props.product.id}
      depots={props.depots}
      isLoading={isLoading}
      submitButtonTitle={'Create'}
      onSubmit={onCreatePromotion}
      cancelButtonTitle={'Cancel'}
      onCancel={() => reduxToggleSidePanel(false)}
    />
  );
}
